{
	"add": {
		"button": "Aggiungi editore",
		"confirm": "Continua",
		"duplicate": "«{{name}}» è già in elenco.",
		"hint": "Aggiungi una casa editrice alla configurazione di questo anno. Scrivi il nome esattamente come su Mr.Book.",
		"open_existing": "Aprilo",
		"placeholder": "Nome della casa editrice",
		"title": "Aggiungi editore"
	},
	"channel": {
		"all": "Tutte",
		"esclusiva": "Esclusiva",
		"ingrosso": "Ingrosso"
	},
	"columns": {
		"channel": "Canale",
		"publisher": "Casa editrice"
	},
	"filter_region": "Regione",
	"no_match": "Nessuna casa editrice corrisponde ai filtri.",
	"page_description": "Canale e regioni di ogni casa editrice, anno per anno. Le modifiche valgono per i nuovi documenti della campagna selezionata.",
	"page_title": "Esclusive",
	"region_header_title": "Editori in esclusiva in {{region}}: {{count}}",
	"region_mark": "Esclusiva in {{region}}",
	"regions": {
		"abruzzo": "Abruzzo",
		"basilicata": "Basilicata",
		"calabria": "Calabria",
		"campania": "Campania",
		"lazio": "Lazio",
		"molise": "Molise",
		"puglia": "Puglia",
		"sardegna": "Sardegna",
		"sicilia": "Sicilia",
		"toscana": "Toscana",
		"umbria": "Umbria"
	},
	"search_placeholder": "Cerca una casa editrice",
	"sheet": {
		"add": "Aggiungi",
		"channel": "Canale",
		"copy_from": "Copia da un altro editore",
		"copy_from_label": "Le combinazioni già in uso, dalla più diffusa",
		"copy_like": "Come {{name}}",
		"copy_like_others_one": "Come {{name}} e un altro",
		"copy_like_others_other": "Come {{name}} e altri {{count}}",
		"effective": "Solo per la campagna {{year}}. I documenti già generati restano invariati.",
		"esclusiva_hint": "Mantegna è distributore esclusivo in almeno una regione. Scorta di sicurezza più alta.",
		"ingrosso_hint": "Nessuna regione in esclusiva. Scorta di sicurezza standard.",
		"regions": "Regioni in esclusiva",
		"regions_count": "{{count}} di {{total}}",
		"regions_required": "Scegli almeno una regione, oppure scegli Ingrosso.",
		"regions_required_new": "Scegli almeno una regione, oppure scegli Ingrosso.",
		"save": "Salva",
		"year": "Configurazione per il {{year}}"
	},
	"toast": {
		"saved": "{{name}}: configurazione {{year}} salvata."
	},
	"year": {
		"copy_from": "Copia da",
		"copy_hint": "Copia editori, canali e regioni da un anno esistente. Puoi modificare la nuova configurazione senza cambiare quella di origine.",
		"create": "Crea anno",
		"created": "Configurazione {{year}} creata.",
		"empty": "Nessuna casa editrice configurata per questo anno.",
		"exists": "Questo anno esiste già. Selezionalo dall’elenco per modificarlo.",
		"label": "Anno",
		"missing": "Il {{year}} non è ancora configurato. Usa «Crea anno» per copiarne uno esistente.",
		"not_created": "Anno non configurato"
	}
}
